import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class AuthentificationService {
    private headers = new Headers({'Content-Type': 'application/json'});
    //private api_url_authentification = './api/switch_db/server.php?cmd=GET_DB_INFOS';
    //private api_url_authentification = './api/server.php?cmd=USER_AUTH';
    private api_url_authentification = './api/switch_site/server.php?cmd=USER_AUTH';
    private api_url_super_users_authentification = './api/server.php?cmd=SUPER_USER_AUTH';
    private api_url_get_socities = './api/switch_db/server.php?cmd=GET_SOCIETIES';
    private api_url_user_check_session = './api/server.php?cmd=USER_SESSION_CHECK';
    private api_url_super_user_check_session = './api/server.php?cmd=SUPPER_USER_SESSION_CHECK';
    private api_url_user_log_out = './api/server.php?cmd=USER_LOG_OUT';
    private api_url_super_log_out = './api/server.php?cmd=SUPER_LOG_OUT';

    constructor(private http: Http) {}

    ValidateAuthentification(login: string, pass: string, society_name: string, id_warehouse: any): Promise<Object> {
        return this.http.get(this.api_url_authentification + '&login=' + login + '&pass=' + pass + '&warehouse=' + society_name + '&id_warehouse=' + id_warehouse)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);

    }

    ValidateSuperUsersAuthentification(login: string, pass: string): Promise<Object> {
        return this.http.get(this.api_url_super_users_authentification + '&login=' + login + '&pass=' + pass)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetSocities(): Promise<Object> {
        return this.http.get(this.api_url_get_socities)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    UserCheckSession(): Promise<Object> {
        return this.http.get(this.api_url_user_check_session)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    SuperUserCheckSession(): Promise<Object> {
        return this.http.get(this.api_url_super_user_check_session)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    LogOut(): Promise<Object> {
        return this.http.get(this.api_url_user_log_out)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    superLogOut(): Promise<Object> {
        return this.http.get(this.api_url_super_log_out)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/authentification.service.ts